// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-component[data-v-3193743d]{min-height:80vh;position:relative}", ""]);
// Exports
module.exports = exports;
